export class ThermicIndexResultComments {

  static getIndexComment = (altitude700Index: number, altitude850Index: number, windSpeed: number): string => {
    let comment = ''


    if (windSpeed <= 15) {
      if (altitude850Index <= 0 && altitude850Index >= -3) {
        comment = 'Termik indeksi, havanın kararlı olduğunu ve tüm seviye pilotlar için uygun uçuş koşulları sunduğunu gösteriyor.';
      } else if (altitude850Index < -3 && altitude850Index >= -6) {
        comment = 'Termik indeksi, orta seviyede termiklerin oluşabileceğini gösteriyor. Bu koşullar <b>P3 ve üzeri</b> seviye pilotlar için uygundur.';
      } else if (altitude850Index < -6 && altitude850Index >= -9) {
        comment = 'Termik indeksi, güçlü termiklerin oluşabileceğini gösteriyor. Bu koşullar <b>P4 ve üzeri</b> seviye pilotlar için uygundur.';
      } else if (altitude850Index < -9) {
        comment = 'Termik indeksi, <b>ÇOK GÜÇLÜ</b> termiklerin oluşabileceğini gösteriyor. Bu koşullar yalnızca <b>P5 ve çok deneyimli</b> pilotlar için uygundur.';
      }

    } else if (windSpeed <= 20) {
      if (altitude850Index <= 0 && altitude850Index >= -6) {
        comment = 'Termik indeksi, orta ile güçlü arası termiklerin oluşabileceğini gösteriyor. Ancak <b>rüzgar hızı arttığından</b> dikkatli olunmalıdır. Bu koşullar <b>P3 ve üzeri</b> seviye pilotlar için uygundur.';
      } else if (altitude850Index < -6 && altitude850Index >= -9) {
        comment = 'Termik indeksi, güçlü termiklerin oluşabileceğini gösteriyor. <b>Rüzgar nedeniyle türbülans artabilir</b>. Bu koşullar <b>P4 ve üzeri</b> seviye pilotlar için uygundur.';
      } else if (altitude850Index < -9) {
        comment = 'Termik indeksi, <b>ÇOK GÜÇLÜ</b> termiklerin oluşabileceğini gösteriyor. <b>20 km/s üzeri rüzgarla birlikte türbülans riski yüksektir</b>. Bu koşullar yalnızca <b>P5 ve çok deneyimli</b> pilotlar için uygundur.';
      }

    } else if (windSpeed > 20) {
      if (altitude850Index <= 0 && altitude850Index >= -6) {
        comment = 'Termik indeksi uygun görünse de, <b>rüzgar hızı 20 km/s üzerinde olduğu için uçuş risklidir</b>. Yalnızca <b>çok deneyimli pilotlar</b> için önerilir.';
      } else if (altitude850Index < -6 && altitude850Index >= -9) {
        comment = 'Güçlü termikler ve <b>20 km/s üzeri rüzgar</b> birleştiğinde <b>şiddetli türbülans</b> oluşabilir. Bu koşullar yalnızca <b>P5 ve çok deneyimli</b> pilotlar için uygundur.';
      } else if (altitude850Index < -9) {
        comment = 'Termik ve rüzgarın birleşimiyle <b>son derece sert hava koşulları</b> oluşabilir. <b>Uçuş tavsiye edilmez</b> — yalnızca <b>P5+ pilotlar</b> ciddi önlemlerle değerlendirmelidir.';
      }
    }

    // 700 hPa seviyesi değerlendirmesi
    if (comment.length > 0) {
      comment += ' Ayrıca,';
    }

    if (altitude700Index >= 0) {
      comment += ' Termik yüksekliğinin 3000 m seviyesini geçemeyeceği öngörülmektedir.';
    } else {
      comment += ' Termik yüksekliğinin 3000 m seviyesini geçebileceği öngörülmektedir.';
    }


    return comment;
  }
}
